'use strict';

const urlJoin = require('url-join');
const { default: stipulate, buildOptions, resolveUrl } = require('stipulate');
const { baseOptions } = require('./configuration');
const config = require('../config');

const passwordResetTokens = (options, query) => {
  if (!options.email) {
    throw new Error('Expected `options.email` to be set');
  }

  const { baseUrl } = config.get();
  let url = urlJoin(baseUrl, 'pb', 'users', 'password-reset-tokens/');
  url = resolveUrl(url, query);

  const requestOptions = buildOptions(baseOptions, {
    method: 'POST',
    body: JSON.stringify(options),
  });

  return stipulate(url, requestOptions, 'blob');
};

const resetPassword = (options, query) => {
  if (!options.token) {
    throw new Error('Expected `options.token` to be set');
  }

  if (!options.password) {
    throw new Error('Expected `options.password` to be set');
  }

  const { baseUrl } = config.get();
  let url = urlJoin(baseUrl, '/pb/users/reset-password/');
  url = resolveUrl(url, query);

  const body = {
    token_id: options.token,
    password: options.password,
  };

  const requestOptions = buildOptions(baseOptions, {
    method: 'POST',
    body: JSON.stringify(body),
  });

  return stipulate(url, requestOptions, 'blob');
};

const changePassword = (options) => {
  if (!options.old_password) {
    throw new Error('Expected `options.old_password` to be set');
  }

  if (!options.new_password) {
    throw new Error('Expected `options.new_password` to be set');
  }

  const { baseUrl } = config.get();
  let url = urlJoin(baseUrl, '/pb/users/me/change-password/');
  url = resolveUrl(url);

  const body = {
    old_password: options.old_password,
    new_password: options.new_password,
  };

  const requestOptions = buildOptions(baseOptions, {
    method: 'POST',
    body: JSON.stringify(body),
  });

  return stipulate(url, requestOptions, 'blob');
}

module.exports = {
  passwordResetTokens,
  resetPassword,
  changePassword,
};
